// Static hosting fallback for Firebase Hosting. Restrict this key in Google AI Studio.
export const GEMINI_API_KEY = 'AIzaSyDjX9tB2OLt5Ksm4Hrs1TKLAUZBNfbOul8'
